import {Directive, ElementRef, EventEmitter, HostListener, Output} from '@angular/core';
import {ConfirmationService} from 'primeng/api';
import {AppService} from '@shared/services/app.service';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[confirmDelete]'
})
export class ConfirmDeleteDirective {
    @Output() confirmDelete = new EventEmitter<any>();

    constructor(private app: AppService) {
    }

    @HostListener('click')
    onClick() {
        this.app.confirmDelete('', () => {
            this.confirmDelete.emit();
        });
    }
}
